// extracted by mini-css-extract-plugin
export var lg = "_37-4";
export var md = "_37-3";
export var sm = "_37-2";
export var xs = "_37-1";
export var xxs = "_37-0";